// extracted by mini-css-extract-plugin
module.exports = {"paginatorContainer":"Paginator_paginatorContainer__2yMZr"};